// filepath: c:\dev\WebModule\src\ui\DealerUI\src\localization\modules\module-registry.ts
import { ITranslationModule } from '../interfaces';
import { AddressEditorModule } from '../webmodule-common/other/ui/address-editor-lang';
import { AppIndexModule } from '../webmodule-common/other/app-index-lang';
import { AuthenticateModalLitModule } from '../webmodule-common/other/ui/loginscreen/authenticate-modal-lit-lang';
import { AutoSaveNotifierModule } from '../webmodule-common/other/context/auto-save-notifier-lang';
import { ContainerManagerModule } from '../webmodule-common/other/container-manager-lang';
import { DataEntryScreenBaseModule } from '../webmodule-common/other/ui/data-entry-screen-base-lang';
import { DevelopmentErrorModule } from '../webmodule-common/other/development-error-lang';
import { FormInputViewModule } from '../webmodule-common/other/ui/templateresult/form-input-view-lang';
import { GooglePlaceAutocompleteModule } from '../webmodule-common/other/ui/maps/google-place-autocomplete-lang';
import { IconNotificationSignalModule } from '../webmodule-common/other/ui/icons/icon-notification-signal-lang';
import { IndexedDbWrapperModule } from '../webmodule-common/database/indexed-db-wrapper-lang';
import { LitTableModule } from '../webmodule-common/components/table/lit-table-lang';
import { LitTableViewModule } from '../webmodule-common/other/ui/littable-view-lang';
import { ModalConfirmationModule } from '../webmodule-common/other/ui/modal-confirmation-lang';
import { ModalConfirmationReasonModule } from '../webmodule-common/other/ui/modal-confirmation-reason-lang';
import { ModalErrorHandlerModule } from '../webmodule-common/other/ui/modal-errorhandler-lang';
import { ModalFooterButtonsModule } from '../webmodule-common/other/ui/modal-footer-buttons-lang';
import { ModalHelperModule } from '../webmodule-common/other/ui/modal-helper-lang';
import { ModalImgModule } from '../webmodule-common/other/ui/modal-img-lang';
import { ModalLoadingModule } from '../webmodule-common/other/ui/modal-loading-lang';
import { ModalOptionModule } from '../webmodule-common/other/ui/modal-option-lang';
import { ModalSavingModule } from '../webmodule-common/other/ui/modal-saving-lang';
import { ModalValidationHandlerModule } from '../webmodule-common/other/ui/modal-validationhandler-lang';
import { OfflineModule } from '../webmodule-common/other/ui/offline-lang';
import { OfflineOverlayModule } from '../webmodule-common/other/ui/offline-overlay-lang';
import { PricingModelModule } from '../webmodule-common/pricing/pricing-model-lang';
import { SampleModule } from './sample-lang-module';
import { SaveWorkflowModule } from '../webmodule-common/other/save-workflow-lang';
import { ShowErrorModule } from '../webmodule-common/other/ui/show-error-lang';
import { StringHelperFunctionsModule } from '../webmodule-common/other/ui/string-helper-functions-lang';
import { ToastAwayModule } from '../webmodule-common/other/toast-away-lang';
import { UserSessionVerifierModule } from '../webmodule-common/other/user-session-verifier-lang';
export function getSupplierLanguageModules(): ITranslationModule[] {
  const modules: ITranslationModule[] = [];
  modules.push(new AddressEditorModule());
  modules.push(new AppIndexModule());
  modules.push(new AuthenticateModalLitModule());
  modules.push(new AutoSaveNotifierModule());
  modules.push(new ContainerManagerModule());
  modules.push(new DataEntryScreenBaseModule());
  modules.push(new DevelopmentErrorModule());
  modules.push(new FormInputViewModule());
  modules.push(new GooglePlaceAutocompleteModule());
  modules.push(new IconNotificationSignalModule());
  modules.push(new IndexedDbWrapperModule());
  modules.push(new LitTableModule());
  modules.push(new LitTableViewModule());
  modules.push(new ModalConfirmationModule());
  modules.push(new ModalConfirmationReasonModule());
  modules.push(new ModalErrorHandlerModule());
  modules.push(new ModalFooterButtonsModule());
  modules.push(new ModalHelperModule());
  modules.push(new ModalImgModule());
  modules.push(new ModalLoadingModule());
  modules.push(new ModalOptionModule());
  modules.push(new ModalSavingModule());
  modules.push(new ModalValidationHandlerModule());
  modules.push(new OfflineModule());
  modules.push(new OfflineOverlayModule());
  modules.push(new PricingModelModule());
  modules.push(new SampleModule());
  modules.push(new SaveWorkflowModule());
  modules.push(new ShowErrorModule());
  modules.push(new StringHelperFunctionsModule());
  modules.push(new ToastAwayModule());
  modules.push(new UserSessionVerifierModule());
  return modules;
}
